import { I18n } from "@/i18n/I18n";
import { Select } from "./Select";
import { useGlobalStore } from "../store/GlobalStore";
import { Form } from "react-bootstrap";

interface UserAssignmentSelectProps {
  assignedUserId: string | null;
  onAssign: (userId: string | null) => void | Promise<void>;
  label?: string;
}

export function UserAssignmentSelect({
  assignedUserId,
  onAssign,
  label,
}: UserAssignmentSelectProps) {
  const users = useGlobalStore(state => state.users);
  const assignedUser = users.find(user => user.id === assignedUserId);
  const labelText = label ?? I18n.get('assignedUser');

  return (
    <Form.Group>
      <Form.Label className="form-label-neutral">{labelText}</Form.Label>
      <Select
        label={labelText}
        value={assignedUser?.email ?? I18n.get('none')}
        neutral
      >
        {assignedUser && (
          <button
            type="button"
            className="w-100 dropdown-item"
            onClick={() => void onAssign(null)}
          >
            {I18n.get('none')}
          </button>
        )}
        {users
          .filter((user) => user.id !== assignedUser?.id)
          .map((user) => (
            <button
              type="button"
              key={user.id}
              className="w-100 dropdown-item"
              onClick={() => void onAssign(user.id)}
            >
              {user.email}
            </button>
          ))}
      </Select>
    </Form.Group>
  );
}
